import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';

import { ApiError, errorMessage } from './api.ts';

/**
 * Puts the API's field errors ({ issues: [{ path, message }] }) on the form fields;
 * returns the general message to show when no field matched.
 */
export function applyApiErrors<T extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<T>,
  fields: readonly Path<T>[],
): string | null {
  if (error instanceof ApiError && error.issues.length > 0) {
    let matched = false;
    for (const issue of error.issues) {
      const field = fields.find((f) => f === issue.path);
      if (field) {
        setError(field, { type: 'server', message: issue.message });
        matched = true;
      }
    }
    if (matched) return null;
  }
  return errorMessage(error);
}
